export const GA_TRACK_EVENTS_ACTIONS = {
  R2SEmailBegin: 'R2SEmailBegin',
  R2SEmailBeginFromURL: 'R2SEmailBeginFromURL',
  R2SEmailInitiated: 'R2SEmailInitiated',
  R2SEmailModalShown: 'R2SEmailModalShown',
  R2SEmailRedirectToASQ: 'R2SEmailRedirectToASQ',
  R2SEmailAttempt: 'R2SEmailAttempt',
  R2SEmailSuccess: 'R2SEmailSuccess',
  R2SEmailFailed: 'R2SEmailFailed',
  R2SEmailCancel: 'R2SEmailCancel',
  R2SBidSuccess: 'R2SBidSuccess',
  R2SPhoneBegin: 'R2SPhoneBegin',
  R2SSMSBegin: 'R2SSMSBegin',
  R2SExternalBegin: 'R2SExternalBegin',
  R2SBINBegin: 'R2SBINBegin',
  PostAdPaidSuccess: 'PostAdPaidSuccess',
  FeatureAdSuccess: 'FeatureAdSuccess',
  PostAdFreeSuccess: 'PostAdFreeSuccess',
  R2SPhoneClicked: 'R2SPhoneClicked',
  CallTrackingPhoneNumber: 'getCallTrackingPhoneNumber',
  AsqFields: 'ASQ_FIELDS',
  AsqCancelled: 'asq_cancelled',
  AsqSendForm: 'asq_send_form',
  AsqWithScheduler: 'asqWithScheduler',
  AsqSelectedCan: 'asq_selected_can',
  AsqToggledTradeIn: 'asq_toggled_trade_in',
  ImageUpload: 'image_upload',
  OKNBannerClick: 'OKNBannerClick',
  OKNModalYes: 'OKNModalYes',
  OKNModalNo: 'OKNModalNo',
  Click: 'Click',
  ShippingAvailable: 'ShippingAvailable',
  BuyFromPartner: 'BuyFromPartner',
  SELLER_INFO_AVAILABLE: 'SellerInformationAvailable',
  SELLER_INFO_RESPONSE_AVAILABLE: 'SellerInformationResponseAvailable',
  OPEN_SELLER_PAGE: 'VipSeeSellerPage',
  SELLER_SMALL_SECTION: 'SellerSmallSectionClick',
  SELLER_REVIEW_CLICK: 'SellerReviewClick',
  SELLER_REVIEW_TAB_CLICK: 'SellerReviewTabClick',
  SELLER_REVIEW_EXTERNAL_LINK_CLICK: 'ExternalReviewsLinkClicked',
};

export const GA_TRACK_EVENTS_LABELS = {
  BuyerProtection: 'BP_Info',
  Shipping: 'Shipping_Info',
  ShippingAllPrices: 'Shipping_Bottom_Sheet',
  ServicePackageContentOpened: 'ServicePackageContentOpened',
  ServicePackageContentClosed: 'ServicePackageContentClosed',
};

export const GAAsqFormStatus = {
  changes: 'changes',
  noChanges: 'no_changes',
} as const;

export const GAImageUploadStatusAction = {
  added: 'added',
  removed: 'removed',
  uploadFailed: 'upload_failed',
  uploadSizeLimitExceeded: 'max_size_exceeded',
} as const;

export const GATradeInStatus = {
  enabled: 'enabled',
  disabled: 'disabled',
  unavailable: 'unavailable',
} as const;

export const GAAsqFieldStatus = {
  empty: 'empty',
  prefilled: 'prefilled',
  filled: 'filled',
} as const;

export const GA_PARAMETER = {
  AD_SELLER_TYPE: 'ad_seller_type',
  AD_HAS_LICENSE_PLATE: 'license_plate',
  BUYER_PROTECTION: 'buyerProtection',
  HAS_SHIPPING: 'shipping_method',
  SHIPPING_COST: 'shipping_price',
  ASKING_PRICE: 'ad_price',
  AD_TYPE: 'ad_type',
  SELLER_ACCOUNT_ID: 'L2_location_ID',
  BUY_IT_NOW: 'BIN_Status',
  ASQ_FORM_ATTRIBUTES: 'asq_form_attributes',
  SELLER_INFO: 'SellerInformation',
  REVIEW_AVERAGE_SCORE: 'average_score',
};

export const DELIVERY_TYPE = {
  PICK_UP: 'Ophalen',
  SHIP: 'Verzenden',
  PICK_UP_OR_SHIP: 'Ophalen of Verzenden',
};

export const ADSENSE_EVENTS = {
  ADSENSE_FOR_SHOPPING_REQUESTED: 'adsenseForShoppingRequested',
  ADSENSE_FOR_SEARCH_REQUESTED: 'adsenseForSearchRequested',
  ADSENSE_FOR_SHOPPING_LOADED: 'adsenseForShoppingLoaded',
  ADSENSE_FOR_SEARCH_LOADED: 'adsenseForSearchLoaded',
};

export const AD_TYPE = {
  VIA_PARTNER: 'ViaPartner',
  ADMARKT: 'Admarkt',
  REGULAR_PAID: 'RegularPaid',
  REGULAR_FREE: 'RegularFree',
} as const;
